import { render } from "./icon-lock.vue?vue&type=template&id=0188191a"
import script from "./icon-lock.vue?vue&type=script&lang=js"
export * from "./icon-lock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__